// src/components/MDNavBar.js
/**
 * Minimal branding strip used on *public* pages (landing, login, sign-up).
 *
 * Layout
 * ┌──────────────────────────────────────────────────────────────┐
 * │ [MD logos…]        ┆   electronRx word-mark + postal address │
 * └──────────────────────────────────────────────────────────────┘
 *
 * No interactivity – purely presentational – so we keep this file tiny and
 * wrap it in `React.memo` to avoid unnecessary re-renders.
 *
 * Props
 * @param {string} [className] – Tailwind utility classes merged into the root
 *        div. Lets parent pages make it `sticky` or change margins.
 */

import React from "react";
import { useTranslation } from "react-i18next";

import LangSwitcher from "../LangSwitcher";

/**
 * Branding-only nav bar shown when the user is **not** authenticated.
 *
 * @param {{ className?: string }} props
 */
function MDNavBar({ className = "" }) {
  const { t } = useTranslation();

  return (
    <div
      className={` bg-background flex items-center gap-4 w-full h-fit p-2 ${className}`}
    >
      <div className="flex items-center gap-4 w-full h-fit p-2">
        {/* Company mark + address ------------------------------------- */}
      </div>
      <LangSwitcher />
    </div>
  );
}

export default React.memo(MDNavBar);
